// third-party
import { createSlice } from '@reduxjs/toolkit';

// types
import { DefaultRootStateProps } from 'types';
import { User } from "../../types/type/users-types";

// ----------------------------------------------------------------------

const initialState: DefaultRootStateProps['student'] = {
    error: null,
    student: [],
    currentStudent: { tutors: [] },
    currentActivities: [],
};

const student = createSlice({
    name: 'student',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        //GET ALL STUDENTS
        getAllStudents(state, action) {
            state.student = action.payload;
        },

        //GET SINGLE STUDENT
        getSingleStudent(state, action) {
            state.currentStudent = action.payload;
        },

        //INSERT NEW STUDENT
        insertNewStudent(state, action) {
            state.student.push(action.payload);
        },

        //UPDATE STUDENT
        updateStudent(state, action) {
            state.student = state.student.map((el: User) => {
                if (el.id == action.payload.id) {
                    el = action.payload
                }
                return el
            })
        },

        //DELETE STUDENT
        deleteStudent(state, action) {
            const index = state.student.findIndex(el => el.id === action.payload)
            if (index > -1) {
                state.student.splice(index, 1);
            }
        },

        //GET ALL STUDENTS
        getActivitiesStudent(state, action) {
            state.currentActivities = action.payload;
        },
    }
});

// Reducer
export default student;

// ---------------------------------------------------------------------